module.exports = __webpack_public_path__ + "20d548bb1c4bd96f4c7917015187d051.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/floral.png
// module id = 2747
// module chunks = 0